module.exports = __webpack_public_path__ + "static/img/derivation-money.572a58e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/derivation-money.svg
// module id = G45s
// module chunks = 31